import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, map, mergeMap, zip } from "rxjs/operators";

import { CommunityService } from "./../data/community.service";
import { OrganizationService } from "./../data/organization.service";
import { UserService } from "./../data/user.service";
import { ModalService } from "./../modal.service";

import { Organization } from "../../types";

@Injectable({
    "providedIn": "root"
})
export class UserResolver implements Resolve<any>{
    private communityService = inject(CommunityService);
    private modalService = inject(ModalService);
    private orgService = inject(OrganizationService);
    private router = inject(Router);
    private userService = inject(UserService);

    resolve (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        const userGuid = route.paramMap.get("userGuid");

        return this.userService.getUserProfile(userGuid).pipe(
            zip(this.orgService.getActiveMarkets()),
            mergeMap(([user, markets]: [any, Organization[]]) => {
                user.userOrgs = (<any[]>user.userOrgs).map((org) => markets.find((m) => m.orgId === org.orgId)).filter(((x) => x !== undefined));

                if (user.subGroup !== null) {
                    user.subGroup.divisionName = markets.find((m) => m.orgId === user.subGroup.divisionID).orgName;
                }

                const divisionIDs: number[] = user.userOrgs.map((org: Organization) => org.orgId);

                if (user.subGroup !== null) {
                    return this.communityService.getCommunities(divisionIDs).pipe(
                        map((r) => {
                            const communities = r;
                            user.subGroup.communities.forEach((community: Organization) => {
                                const comm = communities.find((c) => c.orgId === community.orgId);
                                community.orgId = comm.orgId;
                                community.orgName = comm.orgName;
                                community.sourceKey = comm.sourceKey;
                                community.isActive = comm.isActive;
                            });
                            return user;
                        })
                    );
                } else {
                    return of(user);
                }
            }),
            catchError((err, caught) => {
                this.modalService.showModal({ content: err.error.Message ? err.error.Message : err.error, type: "error", autodismiss: true });
                this.router.navigateByUrl("/admin/users");
                return of(null);
            })
        );
    }
}
